"use strict";
import 'flowbite';
import intlTelInput from 'intl-tel-input';
import Notify from 'simple-notify';
import { tns } from "./node_modules/tiny-slider/src/tiny-slider";
const mailchimp = require("@mailchimp/mailchimp_transactional")(
  "md-FJtuIGn35NSpmcNBGw5JEQ"
);
// app.js

// Get the current URL
var currentUrl = new URL(window.location.href);

// Create a new URLSearchParams object based on the current URL's query parameters
var searchParams = currentUrl.searchParams;

// Remove the desired parameter
searchParams.delete('form_submit');

// Update the query string of the current URL
currentUrl.search = searchParams.toString();

// Replace the current URL with the updated URL
window.history.replaceState({}, '', currentUrl.href);


function validateEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

function getUserLocationInfo(callback) {
  var timeZoneCityToCountry = {
    "Andorra": "Andorra",
    "Dubai": "United Arab Emirates",
    "Kabul": "Afghanistan",
    "Tirane": "Albania",
    "Yerevan": "Armenia",
    "Casey": "Antarctica",
    "Davis": "Antarctica",
    "Mawson": "Antarctica",
    "Palmer": "Antarctica",
    "Rothera": "Antarctica",
    "Troll": "Antarctica",
    "Vostok": "Antarctica",
    "Buenos_Aires": "Argentina",
    "Cordoba": "Argentina",
    "Salta": "Argentina",
    "Jujuy": "Argentina",
    "Tucuman": "Argentina",
    "Catamarca": "Argentina",
    "La_Rioja": "Argentina",
    "San_Juan": "Argentina",
    "Mendoza": "Argentina",
    "San_Luis": "Argentina",
    "Rio_Gallegos": "Argentina",
    "Ushuaia": "Argentina",
    "Pago_Pago": "Samoa (American)",
    "Vienna": "Austria",
    "Lord_Howe": "Australia",
    // .
    // .
    // .
    "Bratislava": "Slovakia",
    "Freetown": "Sierra Leone",
    "San_Marino": "San Marino",
    "Dakar": "Senegal",
    "Mogadishu": "Somalia",
    "Lower_Princes": "St Maarten (Dutch)",
    "Mbabane": "Eswatini (Swaziland)",
    "Lome": "Togo",
    "Port_of_Spain": "Trinidad & Tobago",
    "Dar_es_Salaam": "Tanzania",
    "Kampala": "Uganda",
    "Midway": "US minor outlying islands",
    "Vatican": "Vatican City",
    "St_Vincent": "St Vincent",
    "Tortola": "Virgin Islands (UK)",
    "St_Thomas": "Virgin Islands (US)",
    "Aden": "Yemen",
    "Mayotte": "Mayotte",
    "Lusaka": "Zambia",
    "Harare": "Zimbabwe"
  };



  const countryNameToCountryCode = {
    "Afghanistan": "AF",
    "Åland Islands": "AX",
    "Albania": "AL",
    "Algeria": "DZ",
    "American Samoa": "AS",
    "Andorra": "AD",
    "Angola": "AO",
    "Anguilla": "AI",
    "Antarctica": "AQ",
    "Antigua and Barbuda": "AG",
    "Argentina": "AR",
    "Armenia": "AM",
    "Aruba": "AW",
    "Australia": "AU",
    "Austria": "AT",
    "Azerbaijan": "AZ",
    "Bahamas": "BS",
    "Bahrain": "BH",
    "Bangladesh": "BD",
    "Barbados": "BB",
    "Belarus": "BY",
    "Belgium": "BE",
    "Belize": "BZ",
    "Benin": "BJ",
    "Bermuda": "BM",
    "Bhutan": "BT",
    "Bolivia (Plurinational State of)": "BO",
    "Bonaire, Sint Eustatius and Saba": "BQ",
    "Bosnia and Herzegovina": "BA",
    "Botswana": "BW",
    "Bouvet Island": "BV",
    "Brazil": "BR",
    "British Indian Ocean Territory": "IO",
    "Brunei Darussalam": "BN",
    "Bulgaria": "BG",
    "Burkina Faso": "BF",
    "Burundi": "BI",
    "Cabo Verde": "CV",
    "Cambodia": "KH",
    "Cameroon": "CM",
    "Canada": "CA",
    "Cayman Islands": "KY",
    "Central African Republic": "CF",
    "Chad": "TD",
    "Chile": "CL",
    "China": "CN",
    "Christmas Island": "CX",
    "Cocos (Keeling) Islands": "CC",
    "Colombia": "CO",
    "Comoros": "KM",
    "Congo": "CG",
    "Congo (Democratic Republic of the)": "CD",
    "Cook Islands": "CK",
    "Costa Rica": "CR",
    "Côte d'Ivoire": "CI",
    "Croatia": "HR",
    "Cuba": "CU",
    "Curaçao": "CW",
    "Cyprus": "CY",
    "Czech Republic": "CZ",
    "Denmark": "DK",
    "Djibouti": "DJ",
    "Dominica": "DM",
    "Dominican Republic": "DO",
    "Ecuador": "EC",
    "Egypt": "EG",
    "El Salvador": "SV",
    "Equatorial Guinea": "GQ",
    "Eritrea": "ER",
    "Estonia": "EE",
    "Eswatini": "SZ",
    "Ethiopia": "ET",
    "Falkland Islands (Malvinas)": "FK",
    "Faroe Islands": "FO",
    "Fiji": "FJ",
    "Finland": "FI",
    "France": "FR",
    "French Guiana": "GF",
    "French Polynesia": "PF",
    "French Southern Territories": "TF",
    "Gabon": "GA",
    "Gambia": "GM",
    "Georgia": "GE",
    "Germany": "DE",
    "Ghana": "GH",
    "Gibraltar": "GI",
    "Greece": "GR",
    "Greenland": "GL",
    "Grenada": "GD",
    "Guadeloupe": "GP",
    "Guam": "GU",
    "Guatemala": "GT",
    "Guernsey": "GG",
    "Guinea": "GN",
    "Guinea-Bissau": "GW",
    "Guyana": "GY",
    "Haiti": "HT",
    "Heard Island and McDonald Islands": "HM",
    "Holy See": "VA",
    "Honduras": "HN",
    "Hong Kong": "HK",
    "Hungary": "HU",
    "Iceland": "IS",
    "India": "IN",
    "Indonesia": "ID",
    "Iran (Islamic Republic of)": "IR",
    "Iraq": "IQ",
    "Ireland": "IE",
    "Isle of Man": "IM",
    "Israel": "IL",
    "Italy": "IT",
    "Jamaica": "JM",
    "Japan": "JP",
    "Jersey": "JE",
    "Jordan": "JO",
    "Kazakhstan": "KZ",
    "Kenya": "KE",
    "Kiribati": "KI",
    "Kuwait": "KW",
    "Kyrgyzstan": "KG",
    "Lao People's Democratic Republic": "LA",
    "Latvia": "LV",
    "Lebanon": "LB",
    "Lesotho": "LS",
    "Liberia": "LR",
    "Libya": "LY",
    "Liechtenstein": "LI",
    "Lithuania": "LT",
    "Luxembourg": "LU",
    "Macao": "MO",
    "North Macedonia": "MK",
    "Madagascar": "MG",
    "Malawi": "MW",
    "Malaysia": "MY",
    "Maldives": "MV",
    "Mali": "ML",
    "Malta": "MT",
    "Marshall Islands": "MH",
    "Martinique": "MQ",
    "Mauritania": "MR",
    "Mauritius": "MU",
    "Mayotte": "YT",
    "Mexico": "MX",
    "Micronesia (Federated States of)": "FM",
    "Moldova (Republic of)": "MD",
    "Monaco": "MC",
    "Mongolia": "MN",
    "Montenegro": "ME",
    "Montserrat": "MS",
    "Morocco": "MA",
    "Mozambique": "MZ",
    "Myanmar": "MM",
    "Namibia": "NA",
    "Nauru": "NR",
    "Nepal": "NP",
    "Netherlands": "NL",
    "New Caledonia": "NC",
    "New Zealand": "NZ",
    "Nicaragua": "NI",
    "Niger": "NE",
    "Nigeria": "NG",
    "Niue": "NU",
    "Norfolk Island": "NF",
    "North Korea": "KP",
    "Northern Mariana Islands": "MP",
    "Norway": "NO",
    "Oman": "OM",
    "Pakistan": "PK",
    "Palau": "PW",
    "Palestinian Territories": "PS",
    "Panama": "PA",
    "Papua New Guinea": "PG",
    "Paraguay": "PY",
    "Peru": "PE",
    "Philippines": "PH",
    "Pitcairn Islands": "PN",
    "Poland": "PL",
    "Portugal": "PT",
    "Puerto Rico": "PR",
    "Qatar": "QA",
    "Réunion": "RE",
    "Romania": "RO",
    "Russia": "RU",
    "Rwanda": "RW",
    "Saint Barthélemy": "BL",
    "Saint Helena": "SH",
    "Saint Kitts and Nevis": "KN",
    "Saint Lucia": "LC",
    "Saint Martin (French part)": "MF",
    "Saint Pierre and Miquelon": "PM",
    "Samoa": "WS",
    "San Marino": "SM",
    "São Tomé and Príncipe": "ST",
    "Saudi Arabia": "SA",
    "Senegal": "SN",
    "Serbia": "RS",
    "Seychelles": "SC",
    "Sierra Leone": "SL",
    "Singapore": "SG",
    "Sint Maarten (Dutch part)": "SX",
    "Slovakia": "SK",
    "Slovenia": "SI",
    "Solomon Islands": "SB",
    "Somalia": "SO",
    "South Africa": "ZA",
    "South Georgia and the South Sandwich Islands": "GS",
    "South Korea": "KR",
    "South Sudan": "SS",
    "Spain": "ES",
    "Sri Lanka": "LK",
    "Sudan": "SD",
    "Suriname": "SR",
    "Svalbard and Jan Mayen": "SJ",
    "Sweden": "SE",
    "Switzerland": "CH",
    "Syria": "SY",
    "Taiwan": "TW",
    "Tajikistan": "TJ",
    "Tanzania": "TZ",
    "Thailand": "TH",
    "Timor-Leste": "TL",
    "Togo": "TG",
    "Tokelau": "TK",
    "Tonga": "TO",
    "Trinidad and Tobago": "TT",
    "Tunisia": "TN",
    "Turkey": "TR",
    "Turkmenistan": "TM",
    "Turks and Caicos Islands": "TC",
    "Tuvalu": "TV",
    "Uganda": "UG",
    "Ukraine": "UA",
    "United Arab Emirates": "AE",
    "United Kingdom": "GB",
    "United States": "US",
    "United States Minor Outlying Islands": "UM",
    "Uruguay": "UY",
    "Uzbekistan": "UZ",
    "Vanuatu": "VU",
    "Venezuela": "VE",
    "Vietnam": "VN",
    "Virgin Islands (U.S.)": "VI",
    "Wallis and Futuna": "WF",
    "Western Sahara": "EH",
    "Yemen": "YE",
    "Zambia": "ZM",
    "Zimbabwe": "ZW"
  };

  var userRegion;
  var userCity;
  var userCountry;
  var userTimeZone;
  var userCountryCode;

  if (Intl) {
    userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var tzArr = userTimeZone.split("/");
    userRegion = tzArr[0];
    userCity = tzArr[tzArr.length - 1];
    userCountry = timeZoneCityToCountry[userCity];
    userCountryCode = countryNameToCountryCode[userCountry];
  }
  if(!country_code){
    fetch("https://ipapi.co/json")
    .then(function(res) { return res.json(); })
    .then(function(data) { callback(data.country_code); })
    .catch(function() { callback("us"); });
  }else{
    return {
      'timezone': userTimeZone,
      'region': userRegion,
      'city': userCity,
      'country': userCountry,
      'country_code':userCountryCode
    }
  }
}


const intlOptions={
  preferredCountries: ["AE"],
  separateDialCode: true,
   lazyLoading: true,
   showFlags:true,
   placeholderNumberType: "MOBILE",
  utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
}

if (typeof getUserLocationInfo === 'function') {
  intlOptions.geoIpLookup=getUserLocationInfo;
} else if (typeof getUserLocationInfo === 'object') {
  intlOptions.initialCountry=getUserLocationInfo()['country_code'];
} else {
  intlOptions.initialCountry='AE';
}

document.querySelectorAll(".number").forEach(function (phoneInputField) {
  intlTelInput(phoneInputField, intlOptions);
});

document.querySelectorAll(".number").forEach(function (numberInput) {
  numberInput.addEventListener("keydown", function (event) {
    // Allow backspace and delete keys
    if (event.key === "Backspace" || event.key === "Delete" || event.key === "+") {
        return;
    }

    // Allow only numbers
    if (isNaN(event.key)) {
        event.preventDefault();
    }
  });
});

function serializeForm(form) {
  var formData = new FormData(form);
  var serializedData = [];

  for (var pair of formData.entries()) {
      serializedData.push(encodeURIComponent(pair[0]) + '=' + encodeURIComponent(pair[1]));
  }

  return serializedData.join('&');
}

var sendMailBtn = document.querySelectorAll(".sendMail");
sendMailBtn.forEach(function(sendMailBtn) {
  sendMailBtn.addEventListener("click", function() {
    var self= this;
    var btnName = this.innerText;
    let form = self.closest("form");
    var phoneInputField=form.querySelector(".number");
    var phone_number = window.intlTelInputGlobals.getInstance(phoneInputField).getNumber();;
    // phone number validation
    var numberError = window.intlTelInputGlobals.getInstance(phoneInputField).isValidNumber();


    let fullname = form.querySelector(".name");
    let email = form.querySelector(".email");
    let message = form.querySelector(".message");
    let project_name = "Mag Keturah Reserve";

    var msg ="Request a Call Back";
    if(message.value){
      msg = message.value;
    }

    if (fullname.value == "") {
      new Notify ({
        status: 'error',
        title: 'Error',
        text: 'Please enter your name',
        autoclose: true,
      });
      fullname.focus();
    }else if (fullname.value.length > 30) {
      new Notify ({
        status: 'error',
        title: 'Error',
        text: 'Name is too long',
        autoclose: true,
      });
      fullname.focus();
  } else if (email.value == "") {
        new Notify ({
          status: 'error',
          title: 'Error',
          text: 'Please enter your email address',
          autoclose: true,
        });
        email.focus();
    } else if (!validateEmail(email.value)) {
      new Notify ({
        status: 'error',
        title: 'Error',
        text: 'Please enter valid email address',
        autoclose: true,
      });
      email.focus();
    }else if (form.querySelector(".number").value == "") {
        new Notify ({
          status: 'error',
          title: 'Error',
          text: 'Please enter your phone number',
          autoclose: true,
        });
        form.querySelector(".number").focus();
    }else if (!numberError) {
      new Notify ({
        status: 'error',
        title: 'Error',
        text: 'Invalid phone number length for the selected country',
        autoclose: true,
      });
      form.querySelector(".number").focus();
    }
    else if (msg.length > 500) {
      new Notify ({
        status: 'error',
        title: 'Error',
        text: 'Message is too long',
        autoclose: true,
      });
      message.focus();
    } else if (msg == "") {
      new Notify ({
        status: 'error',
        title: 'Error',
        text: 'Please write your message',
        autoclose: true,
      });
      message.focus();
    } else {
        self.setAttribute('disabled', '');
        self.innerText="Sending...";

        const emailHTML = 
        'Full Name: '+fullname.value+'<br>'+
        'Email: '+email.value+'<br>'+
        'Phone Number: '+phone_number+'<br>'+
        'Message: '+msg+'<br><br><hr><br>'+
        'Type: Off-plan<br>'+
        'Project: '+project_name+'<br>'+
        'Source: Landing page';

        const message = {
          from_email: "inquiry@magketurahreserve.ae",
          subject: "You have recieved new inquiry",
          html: emailHTML,
          to: [
            {
              email: "inquiry@magketurahreserve.ae",
              type: "to",
            },
            {
              email: "excelproperties2@gmail.com",
              type: "cc",
            }
          ]
        };
        
        async function run() {
          const response = await mailchimp.messages.send({
            message
          });
          if(response){
            if(response[0]['status']=='sent'){
              new Notify({
                status: 'success',
                title: 'Success',
                text: 'Thank You, Our team will get back to you soon...',
                autoclose: true,
              });

              var form = document.querySelectorAll("form");
              if (form) {
                for (var i = 0; i < form.length; i++) {
                  form[i].reset();
                }
              }
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                'event': 'cf',
                'response':{
                    'result':'thank_you',
                    'success_msg':'Thank you',
                    'email': email.value,
                    'phone_number': phone_number
                }
              });
            }else{
              new Notify ({
                status: 'error',
                title: 'Error',
                text: 'Something Went wrong! Please try again later...',
                autoclose: true,
              });
            }
            self.removeAttribute('disabled');
            self.innerText=btnName;
          }
        }
        run();
    }
  });
});

    // Get the URL parameter
    function getUrlParameter(name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    function scrollToSectionIfNotScrolled(sectionId) {
      var sectionElement = document.getElementById(sectionId);
      var elements = document.querySelectorAll("li>div.header-section-link");
      if (elements) {
        elements.forEach(function(e) {
          e.classList.remove("!text-[#d8d0c3db]");
        });
      }
      if (sectionElement) {
        var element = document.querySelector('li>div[data-name="'+sectionId+'"]');
        if (element) {
          element.classList.add("!text-[#d8d0c3db]");
        } 
        sectionElement.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
        var navbarBtn=document.querySelector('[data-collapse-toggle="navbar-sticky"]');
        if(navbarBtn.getAttribute("aria-expanded")=="true"){
          navbarBtn.click();
        }
      }
    }
    
    // Usage: Call this function passing the section ID
    var sectionIdParameter = getUrlParameter('section');
    window.addEventListener('DOMContentLoaded', function() {
      setTimeout(() => {
        scrollToSectionIfNotScrolled(sectionIdParameter);
      }, 1000);
     
    });

    document.querySelectorAll(".header-section-link").forEach(function(e){
      e.addEventListener("click", function(){
        const name = this.getAttribute('data-name');
        scrollToSectionIfNotScrolled(name);
        var urlParams = new URLSearchParams(window.location.search);
        urlParams.set('section', name);
        var newUrl = window.location.pathname + '?' + urlParams.toString();
        window.history.pushState({}, '', newUrl);
      });
    });


    document.addEventListener('DOMContentLoaded', function () {
      var slider;
      document.querySelectorAll(".slider-container .slider-items").forEach(e => {
        // Default values
        var defaultItems = 1;
        var defaultGutter = 0;
    
        // Get data attribute values
        var items = e.getAttribute("items");
        var gutter = e.getAttribute("gutter");
    
        // Create an object to store responsive options
        var responsiveOptions = {};
    
        // Define breakpoints and corresponding data attributes
        var breakpoints = {
          sm: 576,
          md: 768,
          lg: 992,
          xl: 1200,
          '2xl': 1440
        };
    
        // Function to extract value for a specific breakpoint
        function getValueForBreakpoint(attribute, breakpoint) {
          var value = e.getAttribute(`${breakpoint}:${attribute}`);
          return value !== null ? value : null;
        }
    
        // Parse the items and gutter values
        function parseValue(value) {
          return !isNaN(value) ? parseFloat(value) : null;
        }
    
        // Loop through the breakpoints and set responsive options
        Object.keys(breakpoints).forEach(breakpoint => {
          var breakpointWidth = breakpoints[breakpoint];
          var itemsForBreakpoint = getValueForBreakpoint('items', breakpoint);
          var gutterForBreakpoint = getValueForBreakpoint('gutter', breakpoint);
    
          if (itemsForBreakpoint !== null) {
            responsiveOptions[breakpointWidth] = {
              items: parseValue(itemsForBreakpoint) || defaultItems,
              gutter: parseValue(gutterForBreakpoint) || defaultGutter
            };
          }
        });
    
        // Set default values if no responsive options are provided
        if (Object.keys(responsiveOptions).length === 0) {
          responsiveOptions[0] = {
            items: defaultItems,
            gutter: defaultGutter
          };
        }
    
        // Check and set default items and gutter values
        if (items !== null && !isNaN(items)) {
          defaultItems = parseFloat(items);
        }
        if (gutter !== null && !isNaN(gutter)) {
          defaultGutter = parseFloat(gutter);
        }
    
        // Get the container for custom indicators
        var customIndicatorsContainer = e.closest('.slider-container').querySelector('.slider-indicators');

        // Initialize TinySlider
        slider=tns({
          container: e,
          items: defaultItems,
          nav: false,
          slideBy: 'page',
          center:true,
          autoplay: true,
          autoplayTimeout:2200,
          autoplayButtonOutput: false,
          gutter: defaultGutter,
          preventScrollOnTouch: 'auto',
          lazyload: true,
          loop: true,
          edgePadding: 0,
          mouseDrag: true,
          controls:false,
          useLocalStorage: true,
          autoHeight: true,
          responsive: responsiveOptions
        });
      });
    });


  function autoAssignImgHeightWidth() {
      // Get references to all image elements
      var images = document.querySelectorAll('img');
      if (images) {
          images.forEach(function (imgEle) {
              // Create a new Image object
              var img = new Image();
  
              // Set the source of the Image object to the same source as the image element
              img.src = imgEle.src;
  
              // Add an event listener to the Image object to run code when it's loaded
              img.addEventListener('load', function () {
                  // Set the width and height attributes of the image element
                  if (!imgEle.getAttribute("width")) {
                      imgEle.width = img.width;
                  }
  
                  if (!imgEle.getAttribute("height")) {
                      imgEle.height = img.height;
                  }
              });
          });
      }
  }autoAssignImgHeightWidth();

  var downloadBrochureBtn = document.querySelector(".downloadBrochureBtn");
  downloadBrochureBtn.addEventListener("click", function() {
    var self= this;
    var btnName = this.innerText;
    var phoneInputField=this.parentNode.parentNode.querySelector(".number");
    var fullname = this.parentNode.parentNode.querySelector(".name");
    var email = this.parentNode.parentNode.querySelector(".email");
    var phone_number = intlTelInputGlobals.getInstance(phoneInputField).getNumber();

    const project_name = "Mag Keturah Reserve";

    if (fullname.value == "") {
        new Notify ({
          status: 'error',
          title: 'Error',
          text: 'Please enter your name',
          autoclose: true,
        });
        this.parentNode.parentNode.querySelector(".name").focus();
    }else if (fullname.value.length > 30) {
        new Notify ({
          status: 'error',
          title: 'Error',
          text: 'Name is too long',
          autoclose: true,
        });
        this.parentNode.parentNode.querySelector(".name").focus();
  } else if (email.value == "") {
        new Notify ({
          status: 'error',
          title: 'Error',
          text: 'Please enter your email address',
          autoclose: true,
        });
        this.parentNode.parentNode.querySelector(".email").focus();
    } else if (!validateEmail(email.value)) {
        new Notify ({
          status: 'error',
          title: 'Error',
          text: 'Please enter valid email address',
          autoclose: true,
        });
        this.parentNode.parentNode.querySelector(".email").focus();
    }else if (phone_number == "") {
        new Notify ({
          status: 'error',
          title: 'Error',
          text: 'Please enter your phone number',
          autoclose: true,
        });
        this.parentNode.parentNode.querySelector(".number").focus();
    }else {
        new Notify ({
          status: 'success',
          title: 'Success',
          text: 'Downloading shortly, please wait...',
          autoclose: true,
        });
        const msg=email.value+" download the Brochure of "+project_name

        self.setAttribute('disabled', '');
        self.innerText="Downloading...";

        const emailHTML = 
        'Full Name: '+fullname.value+'<br>'+
        'Email: '+email.value+'<br>'+
        'Phone Number: '+phone_number+'<br>'+
        'Message: '+msg+'<br><br><hr><br>'+
        'Type: Off-plan<br>'+
        'Project: '+project_name+'<br>'+
        'Source: Landing page';

        const message = {
          from_email: "inquiry@magketurahreserve.ae",
          subject: "Hey! someone downloaded Brochure",
          html: emailHTML,
          to: [
            {
              email: "inquiry@magketurahreserve.ae",
              type: "to",
            },
            {
              email: "excelproperties2@gmail.com",
              type: "cc",
            }
          ]
        };
        message.auto_html = true;
        message.auto_text = true;
        message.charset='utf-8';

        async function run() {
          const response = await mailchimp.messages.send({
            message
          });
          if(response){
            if(response[0]['status']=='sent'){
              var form = document.querySelectorAll("form");
              if (form) {
                for (var i = 0; i < form.length; i++) {
                  form[i].reset();
                }
              }

              document.querySelector("[data-modal-hide='brochure-modal']").click();
              var downloadLink = document.createElement("a");
              downloadLink.href = "static/file/mag-keturah-reserve-dubai-property-brochure.pdf";
              downloadLink.download = "mag-keturah-reserve-dubai-property-brochure.pdf";
              downloadLink.click();
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                'event': 'cf',
                'response':{
                  'result':'thank_you',
                  'success_msg':'Thank you',
                  'email': email.value,
                  'phone_number': phone_number
                }
              });

            }else{
              new Notify ({
                status: 'error',
                title: 'Error',
                text: 'Something Went wrong! Please try again later...',
                autoclose: true,
              });
            }
          }
        }
        run();

        self.removeAttribute('disabled');
        self.innerText=btnName;
    }
  });


  setTimeout(() => {
    document.querySelector("#popup-modal").click();
  }, 4000);


  document.querySelector(".closeWhatsappChat").addEventListener("click", function(e){
    document.querySelector(".closeWhatsappChat ").classList.add("hidden");
    document.querySelector(".whatsappChatContainer").classList.add("hidden");
    document.querySelector(".whatsappChatContainer").classList.remove("mb-1");
  });

  setTimeout(() => {
    document.querySelector(".closeWhatsappChat ").classList.remove("hidden");
    document.querySelector(".whatsappChatContainer").classList.remove("hidden");
  }, 2700);